import elementLocale from 'element-ui/lib/locale/lang/cs-CZ';
import messages from './messages.json';

const updatedElementLocale = { ...elementLocale };
updatedElementLocale.el.datepicker.year = '';
updatedElementLocale.el.pagination.pagesize = ' položek';

const translations = {
  cs: {
    ...messages,
    ...updatedElementLocale,
  },
};

export default translations;
